import { BoxV2 as Box, Flex } from 'portal-commons';
import React, { useState } from 'react';

import { convertTimeWithTimezone } from '@/utils/time';

interface DeclinedExplanationProps {
  rejectionCategory?: string;
  explanation: string;
  date: number;
}

const TruncationThreshold = 400;

const DeclinedExplanation: React.FC<DeclinedExplanationProps> = ({
  rejectionCategory,
  explanation,
  date,
}) => {
  const [showExplanation, setShowExplanation] = useState(
    explanation.length <= TruncationThreshold
  );
  const displayedExplanation = showExplanation
    ? explanation
    : `${explanation.substring(0, TruncationThreshold)}...`;

  return (
    <Flex
      sx={{
        gap: 'xs',
        padding: '16px 20px 20px',
        borderRadius: '10px',
        color: 't.black80',
        background: 't.black05',
      }}
      data-testid="declinedExplanationBlock"
    >
      <Box
        sx={{
          flexShrink: 0,
          width: '160px',
          fontWeight: 400,
          fontSize: 'H300',
          lineHeight: 'normal',
        }}
        data-testid="declinedOn"
      >
        <Box sx={{ mb: 'xxxs', fontWeight: 600 }}>Declined On:</Box>
        <Box>{convertTimeWithTimezone(date, undefined, 'MM-DD-YYYY')}</Box>
      </Box>
      <Box sx={{ fontWeight: 400, fontSize: 'H300', lineHeight: 'normal' }}>
        {rejectionCategory && (
          <Box sx={{ mb: 'xxs' }} data-testid="rejectionCategory">
            <Box as="span" sx={{ fontWeight: 600 }}>
              Rejection Category:{' '}
            </Box>
            <Box as="span">{rejectionCategory}</Box>
          </Box>
        )}
        <Box data-testid="declinedExplanation">
          <Box as="span" sx={{ fontWeight: 600 }}>
            Declined Explanation:{' '}
          </Box>
          <Box as="span" sx={{ wordBreak: 'break-word' }}>
            {displayedExplanation}
          </Box>
        </Box>
        {explanation.length > TruncationThreshold && (
          <Box
            as="button"
            sx={{
              padding: 0,
              mt: 'xs',
              border: 'none',
              color: 't.black80',
              background: 'none',
              fontWeight: 400,
              fontSize: 'H300',
              textDecoration: 'underline',
              cursor: 'pointer',
            }}
            onClick={() => setShowExplanation(!showExplanation)}
            data-testid="toggleVisibilityButton"
          >
            Show {showExplanation ? 'Less' : 'More'}
          </Box>
        )}
      </Box>
    </Flex>
  );
};

export default DeclinedExplanation;
